// Offers page variant switcher with Abra price sync
(() => {
  const CARD = "product-card[data-product-id]";
  const SWATCH = ".variant_swatch";

  function syncVariant(card, swatch) {
    if (!swatch) return;

    const variantId = swatch.getAttribute("data-variant-id");
    if (!variantId) return;

    card.setAttribute("data-variant-id", variantId);

    card.querySelectorAll(SWATCH).forEach((s) => {
      const isActive = s.getAttribute("data-variant-id") === variantId;
      s.classList.toggle("active_swatch", isActive);
      s.setAttribute("aria-checked", String(isActive));
    });

    const idInput = card.querySelector('form input[name="id"]');
    if (idInput) idInput.value = variantId;

    const priceEl = card.querySelector("[ref='priceContainer'], [data-abra-selector]");
    if (priceEl) priceEl.setAttribute("data-variant-id", variantId);
  }

  function resolveHandle(card) {
    if (card.getAttribute("data-product-handle")) return;
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    const match = link.getAttribute("href").match(/\/products\/([^/?#]+)/);
    if (match) card.setAttribute("data-product-handle", match[1]);
  }

  function init() {
    document.querySelectorAll(CARD).forEach((card) => {
      resolveHandle(card);
      syncVariant(card, card.querySelector(`${SWATCH}.active_swatch`));
    });
    if (window.Abra?.render) window.Abra.render();
  }

  document.addEventListener("click", (e) => {
    const swatch = e.target.closest(`${CARD} ${SWATCH}`);
    if (!swatch) return;

    const card = swatch.closest(CARD);
    if (!card) return;

    syncVariant(card, swatch);
    if (window.Abra?.render) window.Abra.render();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Kaching upsell variant picker event
(() => {
  document.addEventListener("change", (e) => {
    const select = e.target.closest(".kaching-product-upsell-item .kaching-cart-selector");
    if (!select) return;
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("kaching:variant-change"));
      if (window.Abra?.render) window.Abra.render();
    }, 500);
  });
})();